define(function (require, exports, module) {
    var isArray = Array.isArray;

    var EMPTYSTRANG = '';
    var SPACE = ' ';
    var W = 'w';

    var ASPECTRATIO = '16:9';
    var SMALL = 320;
    var MEDIUM = 640;
    var LARGE = 960;
    var XLARGE = 1024;
    var rProtocol = /^https?/;
    var HTTPS = 'https';

    function confirmImageRange (cut, range, imageWidth) {
        var isGood = imageWidth === range || !cut;
        var cutWidth;
        if (!isGood) {
            cutWidth = cut.width;
            if (imageWidth > cutWidth && (cutWidth < range)) {
                isGood = true;
            }
        }
        return isGood;
    }

    function cutsObjectToArray (cuts) {
        var cutArray = [];
        var key;
        for (key in cuts) {
            cutArray.push(cuts[key]);
        }
        return cutArray;
    }

    function photoSrcSetHelper (photo) {
        return photo.at2x + SPACE + photo.width + W;
    }

    function ContentPhoto (photo, aspectRatio) {
        aspectRatio = this.aspectRatio = aspectRatio || ASPECTRATIO;
        var splitRatio = aspectRatio.split(':');
        this.aspectRatioWidth = splitRatio[0];
        this.aspectRatioHeight = splitRatio[1];
        this.parseData(photo);
    }

    function removeHttp (image) {
        var temp = {};
        for (var p in image) {
            var isURL = (typeof image[p] === 'string' && (image[p].indexOf('https') >= 0 || image[p].indexOf('http') >= 0));
            temp[p] = (!isURL) ? image[p] : image[p].replace(rProtocol, HTTPS);
        }
        return temp;
    }

    ContentPhoto.prototype = {
        parseData: function (photo) {
            var aspectRatio = this.aspectRatio;
            var images = photo && photo.cuts;
            var i = 0;
            var len;
            var width = this.width = {};
            var small = false;
            var medium = false;
            var large = false;
            var xlarge = false;
            var image;
            var imageWidth;

            var range = this.range = {
                small: false,
                medium: false,
                large: false,
                xlarge: false
            };
            if (images && !isArray(images)) {
                images = cutsObjectToArray(images);
            }
            len = images && images.length;
            if (!len) {
                return;
            }
            for (; i < len; i++) {
                image = removeHttp(images[i]);
                if (image && image.aspectRatio === aspectRatio && image.width) {
                    imageWidth = image.width;

                    if (imageWidth >= SMALL) {
                        width[imageWidth] = image;

                        if (imageWidth < MEDIUM) {
                            if (confirmImageRange(small, SMALL, imageWidth)) {
                                small = image;
                            }
                        } else if (imageWidth < LARGE) {
                            if (confirmImageRange(medium, MEDIUM, imageWidth)) {
                                medium = image;
                            }
                        } else if (imageWidth < XLARGE) {
                            if (confirmImageRange(large, LARGE, imageWidth)) {
                                large = image;
                            }
                        } else {
                            if (confirmImageRange(xlarge, XLARGE, imageWidth)) {
                                xlarge = image;
                            }
                        }
                    }
                }
            }
            range.small = range[SMALL] = small;
            range.medium = range[MEDIUM] = medium;
            range.large = range[LARGE] = large;
            range.xlarge = range[XLARGE] = xlarge;
            range.list = [range.small, range.medium, range.large, range.xlarge].filter(Boolean);
            range.srcSet = range.list.map(photoSrcSetHelper).join() || EMPTYSTRANG;
            this.default = medium || large || small || xlarge;
        }
    };

    return ContentPhoto;
});
